import React, { useEffect, useState } from 'react';
import { FormControlLabel, Checkbox, FormHelperText, Switch, Box, Tooltip } from '@mui/material';
import { UseFormRegisterReturn } from 'react-hook-form';
import useGlobal from 'hooks/useGlobal';
import { HelpOutlineOutlined } from '@mui/icons-material';

const CustomCheckbox: React.FC<{
    label: string;
    helperText?: string;
    helpPopUpText?: string;
    helperErrorText?: string;
    defaultValue?: boolean;
    register?: UseFormRegisterReturn;
    isSwitch?:boolean;
    disabled?:boolean;
    onChange?:(checked: boolean)=>void;
    errors?: {
        [x: string]: any;
    };
}> = (props) => {
    const { label, defaultValue, helperText,helpPopUpText,isSwitch,disabled,onChange, register, errors } = props;
    const [isChecked,setIsChecked] = useState<boolean>(defaultValue === true);
    const { getLocalText} = useGlobal();
    useEffect(()=>{
     
        setIsChecked(defaultValue === true);
    },[defaultValue]);
    
    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) => {
        setIsChecked(checked);
        onChange?.(checked);
    };
    return (
        <>
        <Box
                sx={{
                    display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
                }}
            >
                <FormControlLabel
                    sx={{ mr: 0.5 }}
                    label={getLocalText(label)}
                    control={
                        isSwitch ? (
                            <Switch
                                checked={isChecked}
                                {...register}
                                disabled={disabled}
                                onChange={handleChange}
                            />
                        ) : (
                            <Checkbox
                                checked={isChecked}
                                {...register}
                                disabled={disabled}
                                onChange={handleChange}
                            />
                        )
                    }
                />

                {helpPopUpText && (
                    <Tooltip
                        title={getLocalText(helpPopUpText)}
                        arrow
                        placement="top"
                    >
                        <Box
                            component="span"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                    justifyContent: 'center',
                                color: 'text.secondary',
                                cursor: 'pointer'
                            }}
                        >
                            <HelpOutlineOutlined fontSize='small'
                                
                            />
                        </Box>
                    </Tooltip>
                )}
            </Box>
            <FormHelperText>{(errors && register && errors[register.name] && errors[register.name].message) || getLocalText(helperText || '')}</FormHelperText>
        </>
    );
};
export default CustomCheckbox;
